import React from "react";
import { faqAccordionItemType } from "../common/types";

export function FaqItem({ item }) {
	let link;
	const linkUrl = item.linkUrl;

	if (linkUrl) {
		link = (
			<a href={item.linkUrl} className="btn btn--secondary">
				Learn more
			</a>
		);
	}

	return (
		<>
			<p>{item.content}</p>
			{link}
		</>
	);
}

FaqItem.propTypes = {
	item: faqAccordionItemType.isRequired,
};
